import { render, staticRenderFns } from "./BezorglijstTable.vue?vue&type=template&id=1c99ae78&scoped=true&"
import script from "./BezorglijstTable.vue?vue&type=script&lang=js&"
export * from "./BezorglijstTable.vue?vue&type=script&lang=js&"
import style0 from "./BezorglijstTable.vue?vue&type=style&index=0&id=1c99ae78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c99ae78",
  null
  
)

export default component.exports